import { resolveModuleName } from "typescript";
import { iws_ActionHasConfirmDetail, iws_ActionHasConfirmMaster } from "../../form.ts";
import { IsiButtonType, IsiModeConfirm, IsiShortcut, MenuItemCode } from "../../Isilog.enums";
import { IIsiUIFlowResult } from "../Core/IIsiUIFlowResult";
import { IIsiUIFlowResultGeneric } from "../Core/IIsiUIFlowResultGeneric";
import { IsiActionContext } from "../Core/IsiActionContext";
import { IsiActionRedirect } from "./IsiActionRedirect";


/***
 * Délégué permettant de configurer le formatter d'une colonne.
 * */
interface IIsiConfirmInfo {
    isCancelRet: boolean,
    isValidateRet: boolean,
    askQuestion: boolean

}

enum ConfimationType {
    ConfirmationUtilisateur = 1,
    ValidationImplicite = 2,
    AnnulationImplicite = 3
}



export class IsiConfirmation {

    constructor() {
    }

    /**
     * Lance le merdier de confirmation de validation des modifications
     * @param item
     * @param isTrv
     * @param trvDataKey
     * @param callbackTreatmentArgs
     */
    public LaunchConfirmation(actionContext,isTrv, trvDataKey, callbackTreatmentArgs): Promise<IIsiUIFlowResult> {
        return this._confirmLostModif(actionContext,  isTrv, trvDataKey, callbackTreatmentArgs);
    }

    /**
     * "Gestion" du merdier
     * @param item
     * @param isTrv
     * @param trvDataKey
     * @param callbackTreatmentArgs
     */
    private _confirmLostModif(actionContext: IsiActionContext, isTrv, trvDataKey, callbackTreatmentArgs): Promise<IIsiUIFlowResult> {
        return new Promise((resolve, reject) => {
            screenCore.beforeConfirmLostModifShowPopin(actionContext.uiAction).then(
                (result) => {
                    this._tryShowConfirmPjPopin().then((popinPjFlow) => {
                        if (popinPjFlow.continue) {

                            this._showConfirmPopin(actionContext, isTrv, trvDataKey, callbackTreatmentArgs, result, popinPjFlow).then((popinflow) => {
                                resolve(popinflow);
                            });
                        }
                        else {
                            resolve(popinPjFlow)
                        }
                    });
                }
            );
        });
    }

    /**
     * Affiche la popin de confirmation si des Pj sont encours de transfert.
     * 
     * */
    private _tryShowConfirmPjPopin(): Promise<IIsiUIFlowResult> {
        return new Promise((resolve, reject) => {
            //Des pièces jointes sont en cours d'envoi ? On demande une confirmation avant de quitter
            if (uiCore.getSubmit() && uiCore.existsFilesInQueue()) {
                uiCore.showConfirm({
                    message: uiCore.getMessage("ConfirmExit", "ConfirmCancelAttachmentUpload").IsiLabel,
                    confirmMode: IsiModeConfirm.YesNo,
                    callback: {
                        func: function (response) {
                            if (response === IsiButtonType.Yes) {
                                uiCore.abortAll();
                                resolve({
                                    continue: true,
                                    result: true
                                })
                            } else {
                                resolve({
                                    continue: false,
                                    result: true
                                })
                            }
                        }
                    },
                    id: "ConfirmCancelAttachmentUpload"
                });
            } else {
                resolve({
                    continue: uiCore.getSubmit(),
                    result: true
                })
            }
        })
    }

    /**
     * Lancement de la popin de demande de confirmation de validation/annulation 
     * des modification en cours (biggest merdier ever...).
     * @param item
     * @param bIsTrv
     * @param trvDataKey
     * @param callbackTreatmentArgs
     * @param popinFlow
     */
    private _showConfirmPopin(actionContext: IsiActionContext, bIsTrv, trvDataKey, callbackTreatmentArgs, ask, parentFlow): Promise<IIsiUIFlowResult> {
        return new Promise((resolve, reject) => {
            const item = actionContext.uiAction;
            var ihdSaveResponse = <HTMLInputElement>document.getElementById("ihdSaveResponse");
            var codeMenu = item.menuBarId;
            var codeAction = item.menuItemId;
            var codeItemList = item.codeItemList;
            var result;
            var confirmShowed = false;
            let infoConf: IIsiConfirmInfo;
            let needGlobalResolve = true;
            //ARAN 02/12/2020 [PB0021276]Si l'écran n'a pas les droit d'ajout, on force le traitement en annulation implicite.
            if (!uiCore.formManager.canModify && uiCore.getCursorState() !== CURSOR_STATE_ADD) {
                window.CONFIRM_EXIT = 0;
            }
            //Si la fonction est surcharge, on regarde ce qu'elle renvoit, si elle n'est pas surcharge elle renvoit True

            if (ask) {
                if (typeof (window.CONFIRM_EXIT) != "undefined" && window.CONFIRM_EXIT != 0) {

                    if (window.CONFIRM_EXIT === ConfimationType.ConfirmationUtilisateur ||
                        window.CONFIRM_EXIT === ConfimationType.ValidationImplicite) {

                        var cursorState = screenCore.getCursorState();

                        if ((codeAction === "1" || codeAction === "2" || codeAction === "4")
                            && codeMenu === "CLOSEONCROSS"
                            && isiApp.screen.pageName !== "GLOB005"
                            && window.CONFIRM_EXIT !== ConfimationType.ValidationImplicite) {
                            result = uiCore.getMessage("ConfirmExit", "ConfirmExit").IsiLabel;
                        }
                        // On regarde si le curseur est en ajout ou en modification
                        // TGUE - 15/09/2009 - DYSF30538 - On active la demadne de confirmation en duplication aussi
                        else if ((cursorState === CURSOR_STATE_ADD ||
                            cursorState === CURSOR_STATE_UPDATE ||
                            cursorState === CURSOR_STATE_DUPLICATE)
                            && isiApp.screen.pageName !== "GLOB005") {

                            infoConf = this.evalAskQuestion(codeMenu, codeAction, cursorState)

                            if (window.CONFIRM_EXIT === ConfimationType.ConfirmationUtilisateur) {
                                //Si on pose la question
                                if (screenCore.currentScreen.displayConfirmLostModif(infoConf.askQuestion)) {
                                    var response;
                                    var options = {
                                        oIsTrv: bIsTrv,
                                        actionContext: actionContext,
                                        oTrvDataKey: trvDataKey
                                    }
                                    confirmShowed = true;
                                    if (screenCore.menuManager.IsValideImplicite(codeAction)) {
                                        response = IsiButtonType.Yes
                                        needGlobalResolve = false;
                                        this._confirmLostModifResponse(response, options, parentFlow).then(
                                            (flow) => {
                                                callbackTreatmentArgs.func(flow.reponse, options);
                                                resolve(flow);
                                            }
                                        )
                                    } else {
                                        //Si l'utilisateur clique sur OK alors on valide le traitement sur lequel il a clique
                                        uiCore.showConfirm({
                                            message: uiCore.getMessage("ConfirmExit", "ConfirmExit").IsiLabel,
                                            confirmMode: IsiModeConfirm.YesNoCancel,
                                            callback: {
                                                func: (response) => {
                                                    needGlobalResolve = false;
                                                    this._confirmLostModifResponse(response, options, parentFlow).then(
                                                        (flow) => {
                                                            callbackTreatmentArgs.func(flow.reponse, options);
                                                            resolve(flow);
                                                        })
                                                }
                                            }
                                        });
                                    }
                                } else //Si on ne pose pas la question on renvoit true pour que le traitement continu
                                {

                                    const actionRedirect = uiCore.getActionRedirect();
                                    /***************************************************************************************
                                    * AUTEUR		: ARAN 
                                    * DATE			: 08/03/2012
                                    * DESCRIPTION	: [DEV49681]Gestion du "Valider et Retour" et du "Annuler et Retour"
                                    ****************************************************************************************/
                                    if (infoConf.isCancelRet === true) {
                                        // [CEGO] - 2010.02.19 - [DYSF:34031] : Ajout d'un eventuel code ecran liste.
                                        // Utilise par la fonction RedirectAfterAction de la classe IsiScreenManager cote serveur.
                                        //ARAN 07/10/2009 [DYSF31016]Si on est sur un treeview, on passe un quatrieme parametre contenant la datakey du noeud clique
                                        actionRedirect.setFormCloseAction(trvDataKey);
                                        
                                        result = "PostWithoutSave";
                                    } else if (infoConf.isValidateRet === true) {

                                        // [CEGO] - 2010.02.19 - [DYSF:34031] : Ajout d'un eventuel code ecran liste.
                                        // Utilise par la fonction RedirectAfterAction de la classe IsiScreenManager cote serveur.
                                        //ARAN 07/10/2009 [DYSF31016]Si on est sur un treeview, on passe un quatrieme parametre contenant la datakey du noeud clique
                                        actionRedirect.setFormCloseAction(trvDataKey);

                                        // JSOU - 24/08/2017 - DYSF80518 - On simule maintenant le clic avec la methode openMenu  
                                        screenCore.menuManager.openMenu(MNU_MASTER, IsiShortcut.CstMenuNavigation, FORM_VALIDATEv2);
                                        result = "PostWithSave";
                                    } else {
                                        // LBRI - 2014.08.08 - Pb workflow 
                                        // on passe ici en valudation et en annulation
                                        if (codeAction == FORM_CANCELv2) {
                                            iws_CancelOnConfirmLostModifOverridable();
                                        }
                                        result = "PostWithoutSave";
                                    }
                                }
                            } else {
                                if (infoConf.askQuestion) {

                                    // [LBRI] - 2011.02.02 - [PERF] : le getElementById est fait seulement quand on en a besoin.
                                    const actionRedirect = uiCore.getActionRedirect();
                                    actionRedirect.set(actionContext, null);
                                    // Dysf75304
                                    // HGLE Lors de l'ajout d'une pièce jointe sur un appel en ajout, on ne validait pas un ajout mais une modif
                                    if (cursorState != CURSOR_STATE_ADD) {
                                        //ARAN 12/04/2012 [DYSF49167]On passe le champ cache qui indique l'etat du curseur en consultation
                                        screenCore.setCursorState(CURSOR_STATE_CONSULT);
                                    }

                                    //JSOU - 25/09/2017 - DYSF80518 - On simule maintenant le clic avec la methode openMenu 
                                    screenCore.menuManager.openMenu(MNU_MASTER, IsiShortcut.CstMenuNavigation, FORM_VALIDATEv2);
                                    ihdSaveResponse.value = "PostWithSave";
                                    result = "PostWithSave";

                                } else {
                                    iws_CancelOnConfirmLostModifOverridable();
                                    result = "PostWithoutSave";
                                }
                            }
                        } else // Si on est ni en ajout ni en modif alors on continu le traitement en cours
                        {
                            /***************************************************************************************
                            * AUTEUR		: ARAN 
                            * DATE			: 08/03/2012
                            * DESCRIPTION	: [DEV49681]Gestion du "Valider et Retour" et du "Annuler et Retour"
                            ****************************************************************************************/
                            /* MODIFICATION ---------------------------------------------------------------------------------------------
                            * Auteur      : GLIG
                            * Date        : 04/04/2014
                            * Description : DYSF60987 - Ajout de  sCodeAction == CANCELRETURNv2 pour prendre en compte la fonction "Annuler et Retour"
                            *               de certain ecran
                            *------------------------------------------------------------------------------------------------------------*/
                            if (codeAction == FORM_VALIDATE_RETURNv2 || codeAction == FORM_CANCEL_RETURNv2 || codeAction == CANCELRETURNv2) {

                                const actionRedirect = uiCore.getActionRedirect();
                                // [CEGO] - 2010.02.19 - [DYSF:34031] : Ajout d'un eventuel code ecran liste.
                                // Utilise par la fonction RedirectAfterAction de la classe IsiScreenManager cote serveur.
                                //ARAN 07/10/2009 [DYSF31016]Si on est sur un treeview, on passe un quatrieme parametre contenant la datakey du noeud clique
                                actionRedirect.setFormCloseAction(trvDataKey);

                            }

                            result = "PostWithoutSave";
                        }
                        // Si CONFIRM_EXIT = 3 alors on est en annulation implicite  
                    } else if (window.CONFIRM_EXIT === ConfimationType.AnnulationImplicite) {
                        iws_CancelOnConfirmLostModifOverridable();
                        ihdSaveResponse.value = "PostWithoutSave";
                        result = "PostWithoutSave";
                    }
                } else {
                    result = "PostWithoutSave";
                }

            } else {
                result = iws_CancelLostModif_Overridable();
            }

            if (!confirmShowed && callbackTreatmentArgs) {
                // GBAU - POPIN : Dans le cas ou l'on affiche pas la popup de confirmation, il faut appeler le callback tout de suite
                callbackTreatmentArgs.func(result, true)
            }
            if (needGlobalResolve) {
                resolve({ result: true, continue: true });
            }
        })

    }


    private evalAskQuestion(codeMenu: string, codeAction: string, cursorState: string): IIsiConfirmInfo {
        const result: IIsiConfirmInfo = {
            isCancelRet: false,
            isValidateRet: false,
            askQuestion: false
        };

        switch (codeMenu) {
            //Menu de Navigation                                                                  
            case MNU_MASTER:
            case DIV_LEFT:
                //Si l'utilisateur n'a pas clique pas sur Valider, Valider Retour, Annuler ou Annuler Retour ou Supprimer
                //alors on pose la question
                //<entry mat="ARAN" date="08/10/2018" task="PB0018756">Gestion du publipostage depuis les grilles</entry>
                if (codeAction === MenuItemCode.FORM_CLOSE
                    || codeAction === FORM_ADDv2
                    || codeAction === LAUNCHSEARCHv2
                    || codeAction === FORM_ARCHIVE_MODEv2
                    || codeAction === FORM_NORMAL_MODEv2
                    || codeAction === SEARCHv2
                    || codeAction === DUPLICATEv2
                    || codeAction === FORM_RESTOREv2
                    || codeAction === FORM_ARCHIVE_ONv2
                    || codeAction === WORDv2
                    || codeAction === DATA_WORDv2
                    || codeAction === FORM_EXCELv2
                    || codeAction === FORM_RSSv2
                    || codeAction === FORM_REFRESH
                    || codeAction === DATA_REFRESH
                    || (codeAction === FORM_PROPERTYv2 && isiApp.screen.pageName === "LIST002")
                    || iws_ActionHasConfirmMaster(codeAction)
                    || iws_MenuHasConfirm_overridable(codeMenu, codeAction)
                    || codeAction === ACTIVATE_FOR_PURGE
                    || codeAction === DESACTIVATE_FOR_PURGE) {
                    result.askQuestion = true;
                } else if (codeAction === FORM_VALIDATE_RETURNv2) {
                    result.askQuestion = false;
                    result.isValidateRet = true;
                } else if (codeAction === FORM_CANCEL_RETURNv2) {
                    result.askQuestion = false;
                    result.isCancelRet = true;
                } else if (codeAction === NEWCONFIG_REQUESTv2) { //118272	Développement	T120 à T123 Noyau - Ecran - Popup de confirmation 
                    result.askQuestion = true;
                }
                break;
            //Menu des ecrans                                                                                                                                                                          
            case MNU_PAGE:
			case MNU_EXT_NEWS:
                //Si l'utilisateur change d'ecran via le menu alors on pose la question
                result.askQuestion = true;
                break;
            //Menu Module                                                                                                                                                                      
            case "MODULE":
                var sModuleActuel = (<HTMLInputElement>document.getElementById(IHD_MM_CLICK_ITEM_ID)).value;
                //Si l'utilisateur change de module, sauf module d'inventaire, alors on pose la question
                if ((sModuleActuel !== codeAction) && (sModuleActuel !== 'WI')) {
                    result.askQuestion = true;
                }
                break;
            //Barre de navigation                                                                                                                                                                 
            case "NAVIGATION_TOOLBAR":
                //Si l'utilisateur clique sur la base de navigation du curseur, alors on pose la question
                result.askQuestion = true;
                break;
            //TREEVIEW                                                                                                                                    
            case "TREEVIEW":
                result.askQuestion = true;
                break;
            //Barre de menu                                                                                                                                                                       
            case MNUP_BTN_IWS_CLICK_GR:
                //On gere le cas ou l'utilisateur veut retourner sur la page d'accueil ou veut se deconnecter
                if ((codeAction === HOME) || (codeAction === QUIT)) {
                    result.askQuestion = true;
                }
                break;
            case MNU_ICONE_CLICK_GR:
                //Si on clique sur panier et que l'on avait quelque chose en cours d'edition alors on pose la question fatidique
                if (codeAction === HOMEICONE) {
                    result.askQuestion = true;
                }
                break;
            // VT                                    
            case "VT":
                // si l'utilisateur change la valeur de la combo des requetes
                // GELA - 18/09/2012 - DYSF52104 - Validation/Annulation des modifications avant d'ouvrir la config VT
                switch (codeAction) {
                    case NEWCONFIG_REQUESTv2:
                    case "ComboRequest":
                    case "CHANGEGRIDRENDERMODE":
                        result.askQuestion = true;
                        break;
                }
                break;
            case MNUP_CHG_PROFIL:
                // CLEM - Dysf74182 - Changement des menus profil ne faisant plus le confirm lost modif
                result.askQuestion = true;
                break;
            case "CLOSEONCROSS":
                result.askQuestion = true;
                break;
            case "CHANGELANGUAGE":
                result.askQuestion = true;
                break;
            default:
                if (codeMenu.endsWith(MNU_DETAIL)) {
                    //Si l'utilisateur a fait Ajouter dans un detail (ou sous menu ajouter d'une VA) et que l'on est modification sur le formulaire alors
                    //on propose a l'utilisateur de valider ses modifications.
                    // [LBRI] - 2010/04/21 - [TACHE:33454] : on ne fait le test qu'en statut different d'ajout
                    if (cursorState !== CURSOR_STATE_ADD && (codeAction === DATA_ADDv2 || iws_ActionHasConfirmDetail(codeAction))) {
                        result.askQuestion = true;
                    }
                }
                break;
        }
        return result;
    }

    private _confirmLostModifResponse(response, options, flow: IIsiUIFlowResult): Promise<IIsiUIFlowResultGeneric<string>> {
        return new Promise((resolve, reject) => {
            //118272	Développement	T120 à T123 Noyau - Ecran - Popup de confirmation 

            const ihdSaveResponse = <HTMLInputElement>document.getElementById("ihdSaveResponse");
            const resultFlow: IIsiUIFlowResultGeneric<string> = {
                continue: flow.continue,
                result: flow.result,
                reponse: ""
            }


            if (response === IsiButtonType.Yes) {
                // Dysf75304
                //On enregistre l'ecran puis on redirige
                const actionRedirect = uiCore.getActionRedirect();
                // [CEGO] - 2010.02.19 - [DYSF:34031] : Ajout d'un eventuel code ecran liste.
                // Utilise par la fonction RedirectAfterAction de la classe IsiScreenManager cote serveur.
                //ARAN 07/10/2009 [DYSF31016]Si on est sur un treeview, on passe un quatrieme parametre contenant la datakey du noeud clique
                actionRedirect.set(options.actionContext, options);
               

                // JSOU - 22/08/2017 - DYSF80518 -  On change le mode de fonctionnement de la validation pour que ça fonctionne pour tous les device
                screenCore.menuManager.openMenuById(MNU_MASTER + MNU_SEP + FORM_MNUGRP_NAVIGATION + MNU_SEP + FORM_VALIDATEv2);

                //SDEN DEV 41674, on utilise cette fonction sur la VT et on besoin de connaitre sur quel bouton on a cliquer donc
                // on a defini une valeur de retour pour chaque cas.
                ihdSaveResponse.value = "PostWithSave";
                resultFlow.reponse = ihdSaveResponse.value

            } else if (response === IsiButtonType.No) { //On quite l'ecran sans enregistrer
                //SDEN DEV 41674, on utilise cette fonction sur la VT et on besoin de connaitre sur quel bouton on a cliquer donc
                // on a defini une valeur de retour pour chaque cas.
                // on appel en js cette fonction pour pouvoir effectuer un traitement
                iws_CancelOnConfirmLostModifOverridable();
                ihdSaveResponse.value = "PostWithoutSave";

            } else //Sinon on reste sur l'ecran courant
            {
                //SDEN DEV 41674, on utilise cette fonction sur la VT et on besoin de connaitre sur quel bouton on a cliquer donc
                // on a defini une valeur de retour pour chaque cas.
                ihdSaveResponse.value = "NoPostBack";

            }
            resultFlow.reponse = ihdSaveResponse.value
            resolve(resultFlow);
        })
    }
}
